/* eslint-disable max-classes-per-file */

import Base, { ErrorBase } from 'requests/objects/_base'

/**
 * Sector Object
 */
export default class Sector extends Base {
    /**
     * @param {object} data data
     * @param {number=} data.sectorId sectorId of the Sector
     * @param {string=} data.name name
     */
    constructor({
        sectorId = 0,
        name = '',
        ...data
    } = {}) {
        super(data)
        this.sectorId = sectorId
        this.name = name
    }
}

/**
 * Sector Object used to bind error message
 */
export class ErrorSector extends ErrorBase {
    constructor() {
        super()
        this.sectorId = ''
        this.name = ''
    }
}
